<template>
  <v-card dark color="primary lighten-1" max-width="320" class="mx-5 mb-5" v-if="group.groupName != 'Administrator'">
    
      <v-toolbar flat color="primary">
        <v-card-title light>{{group.groupName}}</v-card-title>
      </v-toolbar>
      <v-card-text>
        <v-item-group multiple>
          <v-item v-for="role in roles" :key="role.id">
            <v-checkbox
              slot-scope="{ active }"
              :selected="active"
              :label="role.roleName"
              @change="SaveRole($event, role.id)"
              :input-value="Getvalue(role.id)"
            />
          </v-item>
        </v-item-group>
      </v-card-text>
    
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  props: ["group", "roles", "grouproles"],

  methods: {
    SaveRole(event, roleID) {
      let groupandroles = {
        groupandroles: {
          companyId: this.$store.getters.user.details.companyId,
          roleId: roleID,
          groupId: this.group.id
        },
        checked: event
      };

      let mutation = `mutation savegroupandroles($groupandroles: SaveGroupAandRoles!,$checked: Boolean!) {
                              savegroupandroles(groupandroles : $groupandroles, checked: $checked ) {
                          id
                        }
                      }`;
      axios
        .post("/graphql", {
          query: mutation,
          variables: groupandroles
        })
        .then(res => {
          if (res.data.data.savegroupandroles) {
            this.showSuccess("Role saved!");
          }
        })
        .catch(() => {
          this.showError("Error while saving role!");
        });
    },
    Getvalue(roleID) {
      if (this.grouproles) {
        var result = this.grouproles.find(
          el => el.groupId == this.group.id && el.roleId == roleID
        );
        if (result != null) {
          return true;
        }
      }
    }
  }
};
</script>

<style>
</style>